import React, { useEffect, useRef } from "react";
import { useGoogleMaps } from "../../context/GoogleMapsContext";
import "./Map.css"; // Import the CSS file for styling

const Map = ({ mapRef, userMarkerRef, directionsServiceRef, directionsRendererRef }) => {
    const { isLoaded, google } = useGoogleMaps();
    const mapContainerRef = useRef(null);
    const destinationMarkerRef = useRef(null);
    const infoWindowRef = useRef(null);

    useEffect(() => {
        if (isLoaded && mapContainerRef.current) {
            mapRef.current = new google.maps.Map(mapContainerRef.current, {
                center: { lat: 48.8735493, lng: 2.3160211 },
                zoom: 16,
            });
            directionsServiceRef.current = new google.maps.DirectionsService();
            directionsRendererRef.current = new google.maps.DirectionsRenderer();
            directionsRendererRef.current.setMap(mapRef.current);

            // Add destination marker
            const destinationPos = { lat: 48.8735493, lng: 2.3160211 };
            destinationMarkerRef.current = new google.maps.Marker({
                position: destinationPos,
                map: mapRef.current,
                title: 'Restaurant Traiteur Au Mirodélice',
            });

            // Create an InfoWindow
            infoWindowRef.current = new google.maps.InfoWindow({
                content: '<div><h1>Au Mirodélice</h1><p>34 Rue de Miromesnil, Paris 75008</p><a href="https://www.google.fr/maps/place/Au+Mirod%C3%A9lice/@48.8735528,2.3134462,17z/data=!3m1!4b1!4m6!3m5!1s0x47e66f867d12760d:0xe4291d99abb41324!8m2!3d48.8735493!4d2.3160211!16s%2Fg%2F11jh2zhlpd?authuser=1&entry=ttu&g_ep=EgoyMDI2MDMyMy4xIKXMDSoASAFQAw%3D%3D" target="_blank" style="color: #DCCA87; text-decoration: none; font-weight: bold;">Voir sur Google Maps</a></div>',
            });

            // Add click event listener to the marker
            destinationMarkerRef.current.addListener('click', () => {
                infoWindowRef.current.open(mapRef.current, destinationMarkerRef.current);
            });
        }
    }, [isLoaded, google, mapRef, directionsServiceRef, directionsRendererRef]);

    if (!isLoaded) {
        return <div>Loading...</div>;
    }

    return (
        <div className="map-container">
            <div ref={mapContainerRef} className="map"></div>
        </div>
    );
};

export default Map;